
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface ReversePositionFieldProps {
  form: UseFormReturn<any>;
  name?: string;
}

export const ReversePositionField = ({ 
  form, 
  name = 'is_reverse_position' 
}: ReversePositionFieldProps) => {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base">
              {t('reverse_positions')}
            </FormLabel>
            <FormDescription>
              {t('reverse_positions_description')}
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
